import * as types from './../constants/actionTypes';

export const alertSuccess = (message) => {
    return {
        type: types.ALERT_SUCCESS,
        message
    };
};

export const alertFailed = (message) => {
    return {
        type: types.ALERT_FAILED,
        message
    };
};

const hideMess = () => {
    return {
        type: types.NOT_SHOW_ALERT_MESSAGE
    };
};

export const hideAlert = () => (dispatch)=> {
    dispatch(hideMess());
};



// WEBPACK FOOTER //
// ./src/actions/AlertActions.js